var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.masikRendszamVisible()
    || _vm.allianzPartnerVisible()
    || _vm.allianzKarVisible())?_c('AjanlatBase',{attrs:{"titleExtra":_vm.titleExtra}},[_c('v-form',{ref:"ajanlat-adatok",attrs:{"slot":"biztositoi-adatok"},slot:"biztositoi-adatok"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.masikRendszamVisible())?_c('BnFormField',{attrs:{"attributes":_vm.masik_rendszam}}):_vm._e(),_vm._v(" "),(_vm.allianzPartnerVisible())?_c('BnFormField',{attrs:{"attributes":_vm.allianz_partner_szerzszam}}):_vm._e(),_vm._v(" "),(_vm.allianzKarVisible())?_vm._l((_vm.getKarEv()),function(ev,index){return _c('BnFormField',{key:index,attrs:{"attributes":{
                        label: 'Károk azonos jármű-kategóriában ' + ev + ' -ben/ban',
                        type: 'select',
                        visible: true,
                        editable: true,
                        help: false,
                        options: [
                            {key: 0, value: 'Nem okoztam kárt' },
                            {key: 1, value: '1 kárt okoztam' },
                            {key: 2, value: '2 kárt okoztam' },
                            {key: 3, value: '3 kárt okoztam' },
                            {key: 4, value: '4 vagy több kárt okoztam'} ],
                        itemsText: 'value',
                        itemsValue: 'key',
                        mezo: 'tf_' + ev + '_kardb',
                        path: 'tarifaData.evenkenti_karok.tf_' + ev + '_kardb'
                    }}})}):_vm._e()],2)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }